import {createSlice} from "@reduxjs/toolkit";

export interface IProcedure {
    id: number | null
    name: string
}

interface IDocProcedure {
    id: number | null
    price: string
    discount: number
    for_child: number | null
    child_price: string
    child_discount: number
    doctor: number | null
    procedures: IProcedure
    child_age_from:string
    child_age_to:string
    is_active:boolean,
    address:number|null
}

interface IInitState {
    procedure: IDocProcedure
}

const initialState: IInitState = {

    procedure: {
        id: null,
        price: '0',
        discount: 0,
        for_child: null,
        child_price: '0',
        child_discount: 0,
        doctor: null,
        procedures: {
            id: null,
            name: ''
        },
        child_age_from:'0 мес.',
        child_age_to:'18 лет',
        is_active:true,
        address:null
    },

}

const procedureReducer = createSlice({
    name: 'procedure',
    reducers: {
        setProcedures: (state, {payload}) => {
            // if (payload.spec_id) {
            //     state.specialities.id = payload.id
            // }
            if (payload.id) {
                state.procedure.id = payload.id
            }
            if (payload.price) {
                state.procedure.price = payload.price
            }
            if (payload.discount) {
                state.procedure.discount = payload.discount
            }
            if (payload.for_child) {
                state.procedure.for_child = 1
            } else if (payload.for_child === null) {
                state.procedure.for_child = null
            } else {
                state.procedure.for_child = 0
            }
            if (payload.child_price) {
                state.procedure.child_price = payload.child_price
            }
            if (payload.child_discount) {
                state.procedure.child_discount = payload.child_discount
            }
            if (payload.doctor) {
                state.procedure.doctor = payload.doctor
            }
            if (payload.procedures) {
                //debugger
                state.procedure.procedures.id = payload.procedures.id
                state.procedure.procedures.name = payload.procedures.name
            }
            if (payload.child_age_from) {
                state.procedure.child_age_from = payload.child_age_from
            }
            if (payload.child_age_to) {
                state.procedure.child_age_to = payload.child_age_to
            }
            // if (payload.is_active) {
                state.procedure.is_active = payload.is_active
            //}
            if (payload.address) {
                state.procedure.address = payload.address
            }

        },
        clearProcedures: (state) => {
            state.procedure.id = null
            state.procedure.price = '0'
            state.procedure.discount = 0
            state.procedure.for_child = null
            state.procedure.child_price = '0'
            state.procedure.child_discount = 0
            state.procedure.procedures.id = null
            state.procedure.procedures.name = ''
            state.procedure.child_age_from = '0 мес.'
            state.procedure.child_age_to = '18 лет'
        },

    },
    initialState,

})

export const {setProcedures, clearProcedures} = procedureReducer.actions
export default procedureReducer.reducer
